import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';

@Component({
    selector: 'que-diagram',
    imports: [CommonModule],
    templateUrl: './diagram.component.html',
    styleUrls: ['./diagram.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiagramComponent {
@Input()
value:string="כן";
@Input()
percentage:number=30;
@Input()
wasChange?:boolean;
@Input()
filterRecipients?:number | null;

showComparison$ = toSignal(inject(DataSummaryStore).showComparison$);
}
